import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserZooGameProps {
    onComplete: () => void;
}

interface PhaserZooGameState {
}

const gameConfig: GameConfig = {
    title: "Zoo Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserZooGame extends React.Component<PhaserZooGameProps, PhaserZooGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserZooGameProps) {
        super(props);
        bindAllOfThis(this, PhaserZooGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserZooGame;



// WEBPACK FOOTER //
// ./src/games/ZooGame/Main.tsx